import { AngularServices, getAngularService } from './get-angular-service';
export const createDeferred = () => getAngularService(AngularServices.Q).defer();
